export const api = {
  protocol: 'https:',
  host: 'finapi.flipkart.com',
  page: '/api/fpg/2/page/fetch',
  fkpayHost: window.location.hostname,
  upiServiceHost: window.location.hostname,
}

export const isDev = false
export const isStage = true
export const isPreprod = false
export const isProd = false
